import React from "react";
import { Wrapper } from "./styles";

export const ModalBody = ({
  margin,
  padding,
  maxHeight,
  align,
  children,
  ...rest
}) => {
  return (
    <Wrapper
      margin={margin}
      padding={padding}
      maxHeight={maxHeight}
      aling={align}
      {...rest}
    >
      {children}
    </Wrapper>
  );
};
